import { getCustomFormConfig } from '../../../bereiche/dateneingabe/co2_custom/getCustomFormConfig';
import { IDs } from '../../../helpers/IDs';
import { isValid } from '../../../main/functions/validData';
import * as Moment from 'moment';
import { fn2, fn0 } from '../../../core/formatter/formatNumber';

/**
 * Hinweis:
 * Das Thema Standorte berücksichtige ich hier noch nicht, das kommt ggf. später, ist dann aber auch keine große Anpassung
 * Ich denke, dass während der Testphase sowieso nur 1 Daenerhebung (nicht nach Standorten) gemacht wird.
 */

export function processVsme(data: any) {
    (data[IDs.ENT_STANDORT] || []).forEach((standort: any) => processVsmeStandort(data, standort));
}

export function processVsmeStandort(data: any, standort: any) {
    const konfig = data[IDs.ENT_KONFIGURATION];
    const use_vsme: boolean = konfig.some((param: any) => param.vsme_orig === 1);
    if (!use_vsme) {
        return;
    }

    const jahrMax = Moment().year();
    let jahrMin = 2010;
    if (konfig && konfig[0] && konfig[0].startjahr_datenerfassung && konfig[0].startjahr_datenerfassung > 1900) {
        jahrMin = konfig[0].startjahr_datenerfassung;
    }
    for (let jahr = jahrMin; jahr <= jahrMax; jahr++) {
        processVsmeJahr(data, standort, jahr);
    }
}

export function processVsmeJahr(data: any, standort: any, jahr: number) {
    // Vorbereitung
    if (!data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme']) {
        data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'] = {};
    }
    if (!data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]) {
        data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid] = { // Hier leer initialisieren
            b1: {} as any,
            b3: {} as any,
            b4: {} as any,
            b5: {} as any,
            b6: {} as any,
            b7: {} as any,
            b9: {} as any,
            b10: {} as any,
            platzhalter: {} as any,
            flags: {} as any,
            available: false
        } as any;
    }
    // Hinweis: available wird gesetzt, wenn mind. 1 Berechnung gemacht wurde
    // Die Berechnungen machen wir in einzelnen Funktionen
    processVsmeJahrB1(data, standort, jahr);
    processVsmeJahrB36(data, standort, jahr);
    processVsmeJahrB4(data, standort, jahr);
    processVsmeJahrB5(data, standort, jahr);
    processVsmeJahrB7(data, standort, jahr);
    processVsmeJahrB8(data, standort, jahr);
    processVsmeJahrB9(data, standort, jahr);
    processVsmeJahrB10(data, standort, jahr);
    processVsmeJahrB12(data, standort, jahr);
    processBPM(data, standort, jahr);

    processAdditionalPlatzhalter(data, standort, jahr);

    if (data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'].available) {
        // console.log('VSME-RES: ', data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme']);
    }
}

function processAdditionalPlatzhalter(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];

    const arr_unt = data[IDs.ENT_UNTERNEHMENSDATEN];
    if (arr_unt && arr_unt.length > 0) {
        const unt = arr_unt[0];
        platzhalter['unternehmen'] = unt.name;

    }
    platzhalter['jahr'] = jahr;
    platzhalter['datum'] = Moment.unix(new Date().getTime() / 1000).format('DD.MM.YYYY');
    platzhalter['wri-link'] = 'www.wri.org';
    platzhalter['etool-link'] = 'www.e-tool.de';
}

function processVsmeJahrB1(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    const arr = (filterStandort(data[IDs.ENT_VSME_B1] || [], standort))
        .filter((item: any) => +item.jahr === jahr && isValid(item, IDs.ENT_VSME_B1, data));
    if (arr.length > 0) {
        const b1_item = arr[0];
        // console.log('VSME B1', jahr, b1_item);
        const crit1 = +b1_item.nettoumsatzerloese;
        const crit2 = +b1_item.anzahl_beschaeftigte;
        const crit3 = +b1_item.bilanzsumme;
        let res = -1;
        if (crit1 === crit2 || crit1 === crit3) {
            res = crit1;
        } else
        if (crit2 === crit3) {
            res = crit2;
        }
        data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b1']['unternehmenseinordnung'] = res;
        if (res === 1) { data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b1']['unternehmenseinordnung_name'] = 'Kleinstunternehmen'; } else
        if (res === 2) { data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b1']['unternehmenseinordnung_name'] = 'Kleinunternehmen'; } else
        if (res === 3) { data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b1']['unternehmenseinordnung_name'] = 'Mittleres Unternehmen'; } else
        if (res === 4) { data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b1']['unternehmenseinordnung_name'] = 'Großunternehmen'; } else {
                         data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b1']['unternehmenseinordnung_name'] = 'Nicht Eindeutig';
        }
        data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'].available = true;
        platzhalter['unternehmensart'] = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b1']['unternehmenseinordnung_name'];
        platzhalter['berichtsform'] = b1_item.bericht + 'er';
    }
}

function processVsmeJahrB36(data: any, standort: any, jahr: number) {
    const arr_b3 = (filterStandort(data[IDs.ENT_VSME_B3] || [], standort)).filter((item: any) => +item.jahr === jahr);
    const b3_data = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b3'];
    const b6_data = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b6'];
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    const flags = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['flags'];
    let item_b3;
    if (arr_b3.length) {
        item_b3 = arr_b3[0];
    }

    const kennziffern = data[IDs.KENNZIFFERN_BERECHNET_STANDORT][standort.tid][jahr] || {};
    if (jahr === 2023) {
        // console.log('VSME B3', jahr, item_b3, standort.tid, kennziffern);
    }
    if (!item_b3 || item_b3.e_tool_nutzung_orig !== 2) {
        // b3_data.strom = kennziffern['verbrauch_strom_konventionell'] || 0;
        // b3_data.stromverbrauch_regenerativ = kennziffern['verbrauch_strom_regenerativ'] || 0;
        // b3_data.fossile_brennstoffe = kennziffern['fossile_brennstoffe_kwh'] || 0;
        // b3_data.energieverbrauch_gesamt = b3_data.strom + b3_data.stromverbrauch_regenerativ + b3_data.fossile_brennstoffe;
        // b3_data.scope1 = kennziffern['co2_fussabdruck_scope1'] || 0;
        // b3_data.scope2 = kennziffern['co2_fussabdruck_scope2'] || 0;
        // b3_data.emissionen_gesamt = b3_data.scope1 + b3_data.scope2;
        const verbrauch_strom_konventionell: number = kennziffern.verbrauch_strom_konventionell;
        const verbrauch_strom_regenerativ: number = kennziffern.verbrauch_strom_regenerativ;
        const fossile_brennstoffe_kwh: number = kennziffern.fossile_brennstoffe_kwh;
        const co2_fussabdruck_scope1: number = kennziffern.co2_fussabdruck_scope1;
        const co2_fussabdruck_scope2: number = kennziffern.co2_fussabdruck_scope2;
        b3_data.strom = typeof verbrauch_strom_konventionell === 'number' && !isNaN(verbrauch_strom_konventionell)
            ? verbrauch_strom_konventionell : null;
        b3_data.stromverbrauch_regenerativ = typeof verbrauch_strom_regenerativ === 'number' && !isNaN(verbrauch_strom_regenerativ)
            ? verbrauch_strom_regenerativ : null;
        b3_data.fossile_brennstoffe = typeof fossile_brennstoffe_kwh === 'number' && !isNaN(fossile_brennstoffe_kwh)
            ? fossile_brennstoffe_kwh : null;
        const hasData: boolean = [b3_data.strom, b3_data.stromverbrauch_regenerativ, b3_data.fossile_brennstoffe]
            .some((value: number) => value !== null);
        b3_data.scope1 = hasData && typeof co2_fussabdruck_scope1 === 'number' && !isNaN(co2_fussabdruck_scope1)
            ? co2_fussabdruck_scope1 : null;
        b3_data.scope2 = hasData && typeof co2_fussabdruck_scope2 === 'number' && !isNaN(co2_fussabdruck_scope2)
            ? co2_fussabdruck_scope2 : null;
        b3_data.energieverbrauch_gesamt = b3_data.strom !== null || b3_data.stromverbrauch_regenerativ !== null
            || b3_data.fossile_brennstoffe !== null
            ? b3_data.strom + b3_data.stromverbrauch_regenerativ + b3_data.fossile_brennstoffe : null;
        b3_data.emissionen_gesamt = b3_data.scope1 !== null || b3_data.scope2 !== null
            ? b3_data.scope1 + b3_data.scope2 : null;

        const gesamtverbrauch = (verbrauch_strom_regenerativ || 0) + (verbrauch_strom_konventionell || 0 ) + (fossile_brennstoffe_kwh || 0);
        platzhalter['b3.gesamtverbrauch'] = fn2(gesamtverbrauch / 1000);
        platzhalter['b3.regenerativ'] = fn2(verbrauch_strom_regenerativ / 1000);
        platzhalter['b3.konventionell'] = fn2(verbrauch_strom_konventionell / 1000);
        platzhalter['b3.fossil'] = fn2(fossile_brennstoffe_kwh / 1000);
        platzhalter['b3.co2_scope1'] = fn2(co2_fussabdruck_scope1);
        platzhalter['b3.co2_scope2'] = fn2(co2_fussabdruck_scope2);
        platzhalter['b3.co2_gesamt'] = fn2(b3_data.emissionen_gesamt);
    } else if (isValid(item_b3, IDs.ENT_VSME_B3, data)) {
        // b3_data.emissionen_gesamt = item_b3.scope1 + item_b3.scope2;
        // b3_data.energieverbrauch_gesamt = item_b3.strom + item_b3.fossile_brennstoffe;
        b3_data.emissionen_gesamt = item_b3.scope1 !== null || item_b3.scope2 !== null ? item_b3.scope1 + item_b3.scope2 : null;
        b3_data.energieverbrauch_gesamt = item_b3.strom !== null || item_b3.fossile_brennstoffe !== null
            ? item_b3.strom + item_b3.fossile_brennstoffe : null;
    }
    ['b3.gesamtverbrauch', 'b3.regenerativ', 'b3.konventionell', 'b3.fossil', 'b3.co2_scope1', 'b3.co2_scope2', 'b3.co2_gesamt']
        .forEach((key: string) => typeof platzhalter[key] === 'undefined' ? platzhalter[key] = 0 : null);
    b6_data.fremdbezug = kennziffern['wasser_verbrauch_jahr'] || 0;
    b6_data.regen_brunnennutzung = kennziffern['regen_brunnennutzung'] || 0;
    b6_data.bezug_gesamt = b6_data.fremdbezug + b6_data.regen_brunnennutzung;

    // Einheit kommt anscheinend immer als m³ aus der Auswertung
    platzhalter['b6.regen'] = fn2(kennziffern['regen_brunnennutzung'] || 0);
    platzhalter['b6.regen_einheit'] = 'm³';
    platzhalter['b6.bezug'] = fn2(kennziffern['wasser_verbrauch_jahr'] || 0);
    platzhalter['b6.bezug_einheit'] = 'm³';
    platzhalter['b6.gesamt'] = fn2(b6_data.bezug_gesamt);
    platzhalter['b6.gesamt_einheit'] = 'm³';

    flags['b6.regen'] = !!b6_data.regen_brunnennutzung;
}
//   data[IDs.KENNZIFFERN_BERECHNET_STANDORT][standort.tid]

function processVsmeJahrB4(data: any, standort: any, jahr: number): void {
    const keys: any = { kategorie_luft: 'Luft', kategorie_wasser: 'Wasser', kategorie_boden: 'Boden' };
    const flags = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['flags'];
    (filterStandort(data[IDs.ENT_VSME_B4], standort)).forEach((item: any) => {
        if (+item.jahr !== jahr || !isValid(item, IDs.ENT_VSME_B4, data)) {
            return;
        }
        const kategorien: string[] = [];
        Object.keys(keys).forEach((key: string) => (item[`${key}_orig`] || item[key]) === 1 ? kategorien.push(keys[key]) : null);
        data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b4[item.tid] = { kategorien };
    });
    flags['b4'] = Object.keys(data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b4).length > 0;
}

function processVsmeJahrB5(data: any, standort: any, jahr: number): void {
    const arr_b5 = (filterStandort(data[IDs.ENT_VSME_B5] || [], standort))
        .filter((item: any) => +item.jahr === jahr && isValid(item, IDs.ENT_VSME_B5, data));
    const arr_b5_last = (filterStandort(data[IDs.ENT_VSME_B5] || [], standort))
        .filter((item: any) => +item.jahr === jahr - 1 && isValid(item, IDs.ENT_VSME_B5, data));
    if (!data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b5) {
        data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b5 = {};
    }
    if (arr_b5.length > 0 && arr_b5_last.length > 0) {
        const item = arr_b5[0];
        const item_last = arr_b5_last[0];
        let einheit = item['einheit']
        if (einheit === 'm2') {
            einheit = 'm²';
        }

        // TODO
        // - Umrechnung Einheiten prüfem (falls in 2 Jahren unterschiedliche einheiten verwendet werden)

        const arr_fields = ['jahr_flaeche_nutzung' , 'jahr_flaeche_versiegelt', 'jahr_flaeche_naturnah_standort', 'jahr_flaeche_naturnah_ausserhalb'];
        arr_fields.forEach((f: string) => {
            if (+item[f] >= 0 && +item_last[f] >= 0) {
                const diff = +item[f] - item_last[f];
                let prozent = 100 / item_last[f] * diff;
                prozent = Math.round(prozent * 100) / 100;
                // Hier die eigentliche Kennzahl --> auskommentiert
                // data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b5['vor' + f + '_veraenderung'] = diff;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b5[`vor${f}_veraenderung`]
                    = typeof item_last[f] === 'number' && !isNaN(item_last[f]) ? diff : null;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b5[`vor${f}_veraenderung_prozent`]
                    = typeof item_last[f] === 'number' && !isNaN(item_last[f]) ? prozent : null;
                // Hier der Layout-String (--> unschön)
                // data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b5['vor' + f + '_veraenderung'] = '#flaechen_aenderung#' + diff + ' ' + einheit + '#' + prozent;
            }
        });
    }
}

function processVsmeJahrB7(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    const flags = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['flags'];
    const arr_b7 = (filterStandort(data[IDs.ENT_VSME_B7] || [], standort))
        .filter((item: any) => +item.jahr === jahr && isValid(item, IDs.ENT_VSME_B7, data));
    const b7_item = arr_b7[0] || {};
    let menge_total = 0;
    (filterStandort(data[IDs.ENT_CO2_SCOPE3_ABFALL], standort)).forEach((item: any) => {
        if (+item.jahr !== jahr || !isValid(item, IDs.ENT_CO2_SCOPE3_ABFALL, data)) {
            return;
        }
        const status: any = getCustomFormConfig(IDs.ENT_CO2_SCOPE3_ABFALL, item, data, null, { jahr, standort_tid: standort.tid }) || {};
        const isHidden = (key: string): boolean => (status[key] || {}).hidden || (status[key] || {}).hidden_input;
        let menge: number = null;

        if (!isHidden('co2_absolut')) {
            menge = item.co2_absolut;
        } else if (!isHidden('menge')) {
            menge = item.menge;
            menge_total += menge;
        } else if (!isHidden('volumen_tonne') && item.leerungen && item.volumen_tonne) {
            menge = item.leerungen * item.volumen_tonne;
            menge_total += menge / 10; // Durch 10 wg. Umrechnung von Liter auf Tonne
        }
        // @DennyKramer Achtung: Kann es hier je Kategorie nur einen Datensatz geben?
        // @MichaelRing: nein, aber es wäre aus meiner Sicht sinnfrei, den Kategoriewert künstlich aufzuteilen
        data[IDs.KENNZIFFERN_BERECHNET][jahr].vsme[standort.tid].b7[item.kategorie] = { menge };
    });
    // console.log('B7:', b7_item);
    if (b7_item.unternehmensverfahren_orig === 1) {
        platzhalter['b7.fuehrt'] = 'führt';
        flags['7'] = true;
    } else {
        platzhalter['b7.fuehrt'] = 'führt keine';
        flags['7'] = false;
    }
    const stoff_anteil = b7_item.verwertbare_stoffe_anteil;
    const recycling_anteil = b7_item.recycling_anteil;
    // b7.recycling_anteil, b7.stoff_anteil, b7.abfall_gesamt
    platzhalter['b7.stoff_anteil'] = stoff_anteil || 0;
    platzhalter['b7.recycling_anteil'] = recycling_anteil || 0;
    platzhalter['b7.abfall_gesamt'] = fn2(menge_total) || 0;
}

function processVsmeJahrB8(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    const arr_bwl = (filterStandort(data[IDs.ENT_BETRIEBSDATEN] || [], standort)).filter((item: any) => +item.jahr === jahr);
    const arr_b8 = (filterStandort(data[IDs.ENT_VSME_B8] || [], standort))
        .filter((item: any) => +item.jahr === jahr);
    const b8_item = arr_b8[0] || {};
    const bwl_item = arr_bwl[0] || {};
    const anz_mitarbeiter = bwl_item.anz_mitarbeiter_real || 0;
    const anz_vollzeit = bwl_item.anz_mitarbeiter || 0;
    const anz_praktikanten = bwl_item.anz_praktikanten || 0;
    const anz_auzubildende = bwl_item.anz_auzubildende || 0;
    const befristet = b8_item.arbeitsvertraege_befristet;
    const unbefristet = b8_item.arbeitsvertraege_unbefristet;
    const anz_m = b8_item.geschlecht_maennlich;
    const anz_w = b8_item.geschlecht_weiblich;
    const anz_d = b8_item.geschlecht_diverse;
    platzhalter['b8.ma_gesamt'] = anz_mitarbeiter || 0;
    platzhalter['b8.ma_vollzeit'] = anz_vollzeit || 0;
    platzhalter['b8.ma_praktikum'] = anz_praktikanten || 0;
    platzhalter['b8.ma_azubi'] = anz_auzubildende || 0;
    platzhalter['b8.ma_befristet'] = befristet || 0;
    platzhalter['b8.ma_unbefristet'] = unbefristet || 0;
    platzhalter['b8.ma_m'] = anz_m || 0;
    platzhalter['b8.ma_w'] = anz_w || 0;
    platzhalter['b8.ma_d'] = anz_d || 0;
    // BP11
    platzhalter['bp11.azubi'] = anz_auzubildende || 0;
    // console.log('B8:', b8_item, bwl_item);
}

function processVsmeJahrB9(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    // Wir brauchen hier die Mitarbeiter aus BWL und die Unfälle aus B9
    const arr_bwl = (filterStandort(data[IDs.ENT_BETRIEBSDATEN] || [], standort)).filter((item: any) => +item.jahr === jahr);
    const arr_b9 = (filterStandort(data[IDs.ENT_VSME_B9] || [], standort))
        .filter((item: any) => +item.jahr === jahr && isValid(item, IDs.ENT_VSME_B9, data));
    const b9_item = arr_b9[0] || {};
    const bwl_item = arr_bwl[0] || {};
    const anz_mitarbeiter = bwl_item.anz_mitarbeiter_real;
    const arbeitsunfaelle = +b9_item.arbeitsunfaelle_orig;
    const arbeitsunfaelle_anzahl = b9_item.arbeitsunfaelle_anzahl;
    const todesfaelle = +b9_item.todesfaelle_orig;
    const todesfaelle_erkrankungen = todesfaelle === 1 ? +b9_item.todesfaelle_erkrankungen : 0;
    const todesfaelle_verletzungen = todesfaelle === 1 ? +b9_item.todesfaelle_verletzungen : 0;
    if (arbeitsunfaelle === 1 && arbeitsunfaelle_anzahl > 0 && anz_mitarbeiter > 0) {
        const quote = arbeitsunfaelle_anzahl / (anz_mitarbeiter * 2000) * 200000;
        data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b9']['arbeitsunfaelle_quote'] = quote;
        data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid].available = true;
        platzhalter['b9.quote_unfaelle'] = fn2(quote);
    } else {
        platzhalter['b9.quote_unfaelle'] = 0;
    }
    platzhalter['b9.todesfaelle_erkrankung'] = todesfaelle_erkrankungen;
    platzhalter['b9.todesfaelle_verletzung'] = todesfaelle_verletzungen;
    platzhalter['b9.unfaelle'] = arbeitsunfaelle_anzahl || 0;
    platzhalter['b10.ma'] = anz_mitarbeiter || 0;
    // console.log('VSME BWL', jahr, bwl_item);
    // console.log('VSME B9', jahr, b9_item);
}

function processVsmeJahrB10(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    const arr = (filterStandort(data[IDs.ENT_VSME_B10] || [], standort))
        .filter((item: any) => +item.jahr === jahr && isValid(item, IDs.ENT_VSME_B10, data));
    const b10_item = arr[0] || {};
    if (Object.keys(b10_item).length) {
        const brutto_m = b10_item['lohn_maennlich'];
        const brutto_w = b10_item['lohn_weiblich'];
        const brutto_d = b10_item['lohn_divers'];
        const lohngefaelle = (brutto_m - brutto_w) / brutto_m * 100;
        data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['b10']['lohngefaelle'] = lohngefaelle;
        platzhalter['b10.lohn_gefaelle'] = fn2(lohngefaelle);
        platzhalter['b10.mindestlohn'] = fn2(b10_item['mindestlohn']);
        platzhalter['b10.einstiegslohn'] = fn2(b10_item['einstiegslohn']);
        platzhalter['b10.lohn_w'] = fn2(brutto_m);
        platzhalter['b10.lohn_m'] = fn2(brutto_w);
        platzhalter['b10.lohn_d'] = fn2(brutto_d);
    } else {
        platzhalter['b10.lohn_gefaelle'] = 0;
        platzhalter['b10.mindestlohn'] = 0;
        platzhalter['b10.einstiegslohn'] = 0;
        platzhalter['b10.lohn_w'] = 0;
        platzhalter['b10.lohn_m'] = 0;
        platzhalter['b10.lohn_d'] = 0;
    }
    platzhalter['b10.tarifvertrag'] = b10_item['mitarbeiter_tarifvertrag'] || 0;
    // , b10.lohn_w, b10.lohn_m, b10.lohn_d, b10.lohn_gefaelle
}

function processVsmeJahrB12(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    const flags = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['flags'];

    const arr_b12 = (filterStandort(data[IDs.ENT_VSME_B12] || [], standort))
        .filter((item: any) => +item.jahr === jahr);
    if (arr_b12.length > 0) {
        const b12_item = arr_b12[0];
        // console.log('B12:', b12_item);
        // b12.verstoesse, b12.geldstrafe
        if (b12_item.verurteilungen_geldbussen_orig === 1) {
            platzhalter['b12.verstoesse'] = b12_item.verurteilungen;
            platzhalter['b12.geldstrafe'] = fn2(b12_item.geldbussen);
            flags['b12'] = true;
        } else {
            flags['b12'] = false;
        }
    }
}

function processBPM(data: any, standort: any, jahr: number) {
    const platzhalter = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['platzhalter'];
    const flags = data[IDs.KENNZIFFERN_BERECHNET][jahr]['vsme'][standort.tid]['flags'];
    const arr_bp2 = (filterStandort(data[IDs.ENT_VSME_BPM2] || [], standort)).filter((item: any) => +item.jahr === jahr);
    const arr_bp5 = (filterStandort(data[IDs.ENT_VSME_BPM5] || [], standort)).filter((item: any) => +item.jahr === jahr);
    const arr_bp6 = (filterStandort(data[IDs.ENT_VSME_BPM6] || [], standort)).filter((item: any) => +item.jahr === jahr);
    const arr_bp10 = (filterStandort(data[IDs.ENT_VSME_BPM10] || [], standort)).filter((item: any) => +item.jahr === jahr);

    if (arr_bp2.length > 0) {
        const bp2_item = arr_bp2[0];
        // console.log('BP2', bp2_item);
        platzhalter['bp2.w'] = bp2_item.mitglieder_weiblich;
        platzhalter['bp2.d'] = bp2_item.mitglieder_divers;
        platzhalter['bp2.m'] = bp2_item.mitglieder_maennlich;
    }
    if (arr_bp5.length > 0) {
        const bp5_item = arr_bp5[0];
        // console.log('BP5', bp5_item);
        platzhalter['bp5.wert'] = fn0(bp5_item.gesamtvermoegensanteil_euro);
        platzhalter['bp5.anteil'] = bp5_item.gesamtvermoegensanteil_prozent;
    }
    if (arr_bp6.length > 0) {
        const bp6_item = arr_bp6[0];
        const bp6_flag = bp6_item.gefaehrliche_radioaktive_abfaelle_orig;
        flags['bp6'] = bp6_flag === 1;
        platzhalter['bp6.radioaktiv'] = bp6_item.radioaktiver_abfall;
        platzhalter['bp6.gefahrstoffe'] = bp6_item.gefahrstoffe;
        // console.log('BP6', bp6_item);
    }
    if (arr_bp10.length > 0) {
        const bp10_item = arr_bp10[0];
        platzhalter['bp10.m'] = bp10_item.anzahl_maennlich_urlaubsanspruch;
        platzhalter['bp10.m2'] = bp10_item.anzahl_maennlich_urlaub;
        platzhalter['bp10.w'] = bp10_item.anzahl_weiblich_urlaubsanspruch;
        platzhalter['bp10.w2'] = bp10_item.anzahl_weiblich_urlaub;
        // console.log('BP10', bp10_item);
    }
}

function filterStandort(arr: any[], standort: any) {
    return (arr || []).filter((row: any) => (row.standort_tid_orig || row.standort_tid) === standort.tid);
}
